module.exports = __webpack_public_path__ + "img/marie.a60473a0.jpg";